import { useEffect } from 'react'
import YogaCalendar from '../../components/YogaCalendar'
import './home.css'

const Home = ({ embedOnly = false }) => {
  useEffect(() => {
    if (embedOnly) {
      document.body.classList.add('embed');
    }
    return () => {
      document.body.classList.remove('embed');
    };
  }, [embedOnly]);

  return (
    <div className={embedOnly ? 'home-embed' : 'home'}>
      <YogaCalendar hideAdminBtn={embedOnly} />
    </div>
  )
}

export default Home
